<mat-menu #paletteMenu="matMenu" [overlapTrigger]="false">
  <div class="color-grid">
    <div
      *ngFor="let color of colors"
      class="color-box"
      [ngStyle]="{
        'background-color': color,
        'border': color === selectedColor ? '3px solid black' : '1px solid gray'
      }"
      (click)="$event.stopPropagation(); selectColor(color)"
    ></div>
  </div>
</mat-menu>

<button mat-icon-button [matMenuTriggerFor]="paletteMenu" #menuTrigger="matMenuTrigger">
  <mat-icon>palette</mat-icon>
</button>
